import React from 'react';
import { WatcherProps } from '../watcher.interface';
import { getFieldNames } from '../utils/getFieldsNames';

/**
 * Watch for user maked changes in form
 */
export const useWatcher = ({ form, submit, defaultValues, careerId, catalogType }: WatcherProps) => {
  React.useEffect(() => {
    const subscription = form.watch((values, info) => {
      if (info.type !== 'change') {
        return;
      }

      /**
       * Filter changes
       */
      const fieldsToWatch = getFieldNames({ catalogType, careerId });

      const isFilterChanged = fieldsToWatch.find((fieldName) => values[fieldName] !== defaultValues[fieldName]);

      if (isFilterChanged) {
        submit();
      }
    });
    return () => subscription.unsubscribe();
  }, [careerId, catalogType, defaultValues, form, submit]);
};
